import React from "react";

export default function ItemBar({ isAnimating, handlers }) {
  const items = [
    { onClick: handlers.handleBazooka, src: "/bazooka.png", alt: "Bazooka" },
    { onClick: handlers.handleSaber, src: "/lightsaber.png", alt: "Lightsaber" },
    { onClick: handlers.handleVan, src: "/van.png", alt: "Van" },
    { onClick: handlers.handleGarry, src: "/garrytanIcon.webp", alt: "Garry Tan" },
    { onClick: handlers.handleGlock, src: "/glock.png", alt: "Glock" },
    { onClick: handlers.handleMarc, src: "/marcandersen.png", alt: "Marc Andreessen" },
    { onClick: handlers.handleClaude, src: "/claude.svg", alt: "Claude" },
  ];

  const emptySlots = 7 - items.length;

  return (
    <div className="item-buttons">
      {items.map((item, i) => (
        <button key={i} className="item-btn" onClick={item.onClick} disabled={isAnimating} aria-label={item.alt}>
          <img src={item.src} alt={item.alt} className="item-btn-img" draggable={false} />
        </button>
      ))}
      {Array.from({ length: emptySlots }).map((_, i) => (
        <div key={`empty-${i}`} className="item-btn item-btn-empty" />
      ))}
    </div>
  );
}
